/**
 * @desc 根据多个FNSKU获取对应的sku
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.omsFlow.MskuRequestRpcDto>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/msku/getByFnskuList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
